/* JAEL Café — respaldo de acordeón exclusivo.
   Los navegadores que ya soportan el atributo `name` en <details> no necesitan
   nada: el script se retira solo. En los demás, abrir una pregunta cierra las
   otras del mismo grupo. */
(function () {
  'use strict';

  var soportaNombre = 'name' in document.createElement('details');
  if (soportaNombre) return;

  document.addEventListener('toggle', function (evento) {
    var abierto = evento.target;
    if (!abierto.matches('details[data-jael-grupo]') || !abierto.open) return;

    var grupo = abierto.getAttribute('data-jael-grupo');
    document.querySelectorAll('details[data-jael-grupo="' + grupo + '"]').forEach(function (otro) {
      if (otro !== abierto) otro.open = false;
    });
  }, true);
})();
